import * as React from 'react';
import { Stack, Typography, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { BaseInputField } from '../style/textfield';
import { TypographyNomal, TypographyNomalBold, TypographyAbnomalBold } from '../style/typography';
import { BoxSpaceWrap } from '../style/box';
import { formatteDateTimeZone } from "../func/util";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { APPROVAL_STATUS } from '../const/config';

export default function ApprovalStatusInfo({ approval, approvalStatus}) {

    // 承認データの最新
    const latestAppoval = approval.length > 0 ? approval[0] : null;

    // 日時をフォーマット
    const formattedRequestedAt = (latestAppoval !== null) ?  formatteDateTimeZone(latestAppoval.requested_at) : "";

    return (
        <>
            <Grid container spacing={5} columns={12} p={2}>
                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                    <BoxSpaceWrap>
                        <TypographyNomalBold>承認依頼日時</TypographyNomalBold>
                        <TypographyNomal>{formattedRequestedAt}</TypographyNomal>
                    </BoxSpaceWrap>
                </Grid>
                {latestAppoval ? (
                    <>
                        <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                            <BoxSpaceWrap>
                                <TypographyNomalBold>承認依頼者</TypographyNomalBold>
                                <TypographyNomal>{latestAppoval.requested_by_name}</TypographyNomal>
                            </BoxSpaceWrap>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                            <BoxSpaceWrap>
                                <TypographyNomalBold>承認状況</TypographyNomalBold>
                                {approvalStatus !== APPROVAL_STATUS.REMAND ? 
                                    <TypographyNomal>{approvalStatus === APPROVAL_STATUS.APPROVED ? '承認済み' : '承認待ち'}</TypographyNomal>
                                    :
                                    <TypographyAbnomalBold>差戻し</TypographyAbnomalBold>
                                }
                            </BoxSpaceWrap>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                            <BoxSpaceWrap>
                                <TypographyNomalBold>コメント</TypographyNomalBold>
                                <TypographyAbnomalBold>{latestAppoval.note}</TypographyAbnomalBold>
                            </BoxSpaceWrap>
                        </Grid>
                    </>
                ) : (
                    <Grid size={12}>
                        <TypographyNomal>承認データがありません。</TypographyNomal>
                    </Grid>
                )}
            </Grid>
        </>
    );
}
